class CollectionSliderNav {
  constructor() {
    this.buttons = document.querySelectorAll('.collection__title-nav-buttons .slider-button');
    if (!this.buttons.length) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    // Keep disabled states in sync as the user scrolls manually (touch/trackpad)
    this.sliders = new Set();
    this.buttons.forEach((button) => {
      const slider = document.getElementById(button.getAttribute('aria-controls'));
      if (slider) this.sliders.add(slider);
    });

    this.sliders.forEach((slider) => {
      slider.addEventListener('scroll', () => this.updateDisabledState(slider), { passive: true });
      this.updateDisabledState(slider);
    });
  }

  onButtonClick(event) {
    const button = event.currentTarget;
    const sliderId = button.getAttribute('aria-controls');
    const slider = document.getElementById(sliderId);
    if (!slider) return;

    const step = this.getStep(slider);
    const isPrev = button.classList.contains('slider-button--prev');

    slider.scrollBy({
      left: isPrev ? -step : step,
      behavior: 'smooth',
    });
  }

  getStep(slider) {
    const firstItem = slider.querySelector('.grid__item');
    if (!firstItem) return slider.clientWidth;

    const itemWidth = firstItem.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(slider).columnGap || getComputedStyle(slider).gap || '0');

    return itemWidth + gap;
  }

  updateDisabledState(slider) {
    const prevButton = document.querySelector(
      `.collection__title-nav-buttons .slider-button--prev[aria-controls="${slider.id}"]`
    );
    const nextButton = document.querySelector(
      `.collection__title-nav-buttons .slider-button--next[aria-controls="${slider.id}"]`
    );

    const maxScrollLeft = slider.scrollWidth - slider.clientWidth - 1; // -1 for rounding safety

    if (prevButton) prevButton.disabled = slider.scrollLeft <= 0;
    if (nextButton) nextButton.disabled = slider.scrollLeft >= maxScrollLeft;
  }
}

document.addEventListener('DOMContentLoaded', () => new CollectionSliderNav());